module.exports = __webpack_public_path__ + "static/media/slack-default.68530c8b.svg";